import { LegacyPagePaths } from "App/routes/paths";

import { QueuesRerouter } from "./QueuesRoutingPage";

import type { RegalRouteObject } from "App/routes/types";

export const rerouteQueuesRoute: RegalRouteObject = {
    path: LegacyPagePaths.queues,
    element: <QueuesRerouter />,
    children: [
        {
            path: "*",
            element: <QueuesRerouter />,
        },
    ],
};
